import { DeepReadonlyObject } from 'rxdb';

import {
	LegView,
	TKissOrRide,
	TripTypeEnum,
	TTripType,
} from '@mopla/data-models';

export const getTripType = (
	itineraryLegs: DeepReadonlyObject<LegView[]>
): TTripType => {
	const tripTypes: TKissOrRide[] = [];
	let hasPRODT = false;

	let defaultKissMode: TripTypeEnum.LBODT | TripTypeEnum.LBODTFLEX =
		TripTypeEnum.LBODT;

	itineraryLegs.forEach((leg) => {
		const { mode } = leg;

		if (mode === TripTypeEnum.PRODT) {
			hasPRODT = true;
		}

		if (
			mode === TripTypeEnum.LBT ||
			mode === TripTypeEnum.LBODT ||
			mode === TripTypeEnum.LBODTFLEX
		) {
			if (mode === TripTypeEnum.LBT) {
				tripTypes.push('R');
			} else {
				tripTypes.push('K');
				defaultKissMode = mode;
			}
		}
	});

	if (hasPRODT) {
		return TripTypeEnum.PRODT;
	}

	const uniqueTypes = new Set(tripTypes);
	if (uniqueTypes.size === 1) {
		return tripTypes[0] === 'R' ? TripTypeEnum.LBT : defaultKissMode;
	}

	const tripString = tripTypes.join('');

	if (/K.*R.*K/.test(tripString)) {
		return 'KRK';
	}

	return tripString.startsWith('R') ? 'RK' : 'KR';
};
